import { Placement } from '@popperjs/core'
import { ReactElement, useRef } from 'react'
import { Tooltip as BootstrapTooltip, Overlay } from 'react-bootstrap'
import { I18n } from 'common'
import { zIndex } from '../../theme/zIndex'

interface TooltipProps {
  message?: string
  children: ReactElement
  show?: boolean
  content?: ReactElement
  onClose?: () => void
  placement?: Placement
  textColor?: string
}

/**
 * @deprecated
 * In favor of MUI tooltip customization
 * See MUITooltipCustomization.tsx
 *
 */
export const Tooltip = (props: TooltipProps): ReactElement => {
  const {
    children,
    message,
    show = true,
    content,
    onClose,
    placement = 'top',
    textColor = 'inherit',
  } = props
  const target = useRef<HTMLDivElement>(null)

  if (!message && !content) {
    return children
  }

  return (
    <>
      <div ref={target} style={{ width: '100%' }}>
        {children}
      </div>
      <Overlay
        target={target.current}
        show={show}
        placement={placement}
        rootClose={onClose ? true : false}
        onHide={() => {
          if (onClose) {
            onClose()
          }
        }}
      >
        {(props) => (
          <BootstrapTooltip
            {...props}
            id="tooltip"
            style={{
              ...props.style,
              zIndex: zIndex.tooltipInModal,
              width: '185px',
            }}
          >
            <div style={{ textAlign: 'left', color: textColor }}>
              <I18n name={message || ''} />
            </div>
            {content}
          </BootstrapTooltip>
        )}
      </Overlay>
    </>
  )
}
